<template>
	<div :class="{'form-input': true, 'error': errors.has(name), 'no-empty': value.length > 0}" :id="[`form-input--${name}`]">
		<input
			:type="type"
			:name="name"
			:id="name"
			:required="required ? required : null"
			:value="value"
			@input="$emit('input', $event.target.value)"
			v-validate="validate"
			ref="input"
		/>
		<label :for="name" @click="focus"><slot/></label>
	</div>
</template>

<script>
export default {
	inject: ['$validator'],
	props: {
		type: {
			type: String,
			default: 'text',
		},
		name: {
			type: String,
			default: '',
		},
		required: {
			type: String,
			default: null,
		},
		validate: {
			type: [String, Object],
			default: '',
		},
		value: {
			type: String,
			default: '',
		},
	},
	methods: {
		focus () {
			this.$refs.input.focus();
		},
	},
};
</script>

<style lang=less scoped>
	@import (reference) '../assets/less/default.less';
	@import '../assets/less/form-input.less';
</style>



// WEBPACK FOOTER //
// src/components/BaseInput.vue